var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMyPageOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected=True, Name=My"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 6C44.2843 6 51 12.7157 51 21C51 25.1108 49.3464 28.8353 46.6681 31.5448C48.1304 31.946 49.5774 32.4309 51 33L53.4656 33.9862C61.0359 37.0144 66 44.3465 66 52.5C66 59.9558 59.9558 66 52.5 66H19.5C12.0442 66 6 59.9558 6 52.5C6 44.3465 10.9641 37.0144 18.5344 33.9862L21 33C22.4226 32.4309 23.8696 31.946 25.3336 31.5451C22.6536 28.8353 21 25.1108 21 21C21 12.7157 27.7157 6 36 6Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMyPageOn);
export default __webpack_public_path__ + "static/media/footer-my-page-on.37cfb2b773ec709848978c37edd38dbc.svg";
export { ForwardRef as ReactComponent };